import {computed, inject, nextTick, ref} from 'vue'
import localize from '@vueform/vueform/src/utils/localize.js'
import axios from "@vueform/vueform/src/services/axios";
import RepeaterElement from "./RepeaterElement.vue";
import SelfieElement from "./SelfieElement.vue";
import {Validator, date as VueformDate} from "@vueform/vueform";

const RepeaterPlugin = {
    apply: 'ListElement',
    props: {listType: {required: false, type: String}},
    setup(props, context, component) {
        if (props.listType === 'repeater') {
            const hasContactForm = !!component.form$.value.$attrs.hasContactPersonField;
            const isUpdate = !!component.form$.value.$attrs.isUpdate;
            const translations = component.form$.value.translations;

            component.addLabel = translations.festiware.repeater.add
            component.template = RepeaterElement;
            component.hidden_is_owner_person = false;
            // toggle remove if owner-person
            component.hasRemove = (i) => {
                const value = component.value.value[i];
                return !value?.has_redeemed_tickets && !parseInt(value?.is_owner_person ?? 0) && (isUpdate || props.min < Object.entries(component.value.value).length)
            };

            if (component.form$.value.$attrs.requiresContactPerson) {
                if (!hasContactForm && !isUpdate) {
                    component.update([{is_owner_person: 1}]);
                }
                // add radio button for contact person
                component.prototype = computed((el) => {
                    // schema for contact person
                    const contact_schema = component.form$.value.$attrs.contact_schema;
                    let schema = props.object.schema;

                    // CASE ONE (owner_person field present)
                    if (hasContactForm && !isUpdate) {
                        schema = {};
                        Object.keys(props.object.schema).forEach(key => {
                            const field = props.object.schema[key];
                            if (contact_schema && contact_schema[key]) {
                                field.conditions = field.conditions || [];
                                if (contact_schema[key] != 'undefined') {
                                    if (!component.form$.value.$attrs.personFieldBeforeRepeater) {
                                        field.onChange = function(newVal, oldVal, el$) {
                                            //el$.form$.el$('owner_person').update()
                                            if (el$.parent.value['is_owner_person']) {
                                                component.form$.value.elements$.owner_person.value[el$.name] = newVal
                                            }
                                        }
                                    } else {
                                        field.disabled = function(el$, form$) {
                                            return el$.parent.value['is_owner_person']
                                        }
                                    }
                                }
                                //field.conditions.push([component.dataPath.value + '.*.is_owner_person', 0]);
                            }
                            schema[key] = field;
                        })
                        schema = Object.assign({
                            is_owner_person: {default: 0, type: 'checkbox'},
                            /*is_owner_person_hint: {
                                type: 'static',
                                content: translations.festiware.repeater.is_owner_person_hint,
                                conditions: [[component.dataPath.value + '.*.is_owner_person', 1]]
                            }*/
                        }, schema);
                    // CASE TWO (no owner_person field present)
                    } else if (!hasContactForm) {
                        if (!isUpdate) {
                            Object.keys(contact_schema).forEach(key => {
                                const field = contact_schema[key];
                                field.conditions = field.conditions || [];
                                if (!props.object.schema[key]) {
                                    field.conditions.push([component.dataPath.value + '.*.is_owner_person', 1]);
//                                    field.conditions.push([component.dataPath.value + '.*.index', 0]);
                                }
                            })
                            schema = Object.assign({
                                is_owner_person: {
                                    default: 0,
                                    type: !isUpdate ? 'radio':'radio',
                                    meta: true,
                                }
                            }, schema, contact_schema);
                        } else {
/*
                            schema = Object.assign({
                                is_owner_person: {
                                    default: 0,
                                    type: !isUpdate ? 'hidden':'radio',
                                    meta: true,
                                }
                            }, schema);
*/
                        }
                    }

                    if (schema.is_owner_person) {
                        schema.is_owner_person.text = translations.festiware.repeater.is_owner_person;
                        schema.is_owner_person.onChange = (newVal, oldVal, $el) => {
                            if (component.isUpdatingRepeaterFields) {
                                return
                            }
                            const listElement = $el.$parent.$parent.$parent.$parent;
                            listElement.children$Array.forEach(child => {
                                if (isUpdate && newVal && child.$el === $el.$parent.$parent.$el) {
                                    UIkit.modal.alert($el.form$.translations.festiware.repeater.change_owner_person)
                                }
                                if (newVal && child.$el !== $el.$parent.$parent.$el) {
                                    child.update({is_owner_person: 0});
                                }
                            })
                            // update contact person fields OR disable contact person fields on is_owner_person change
                            if (hasContactForm && !component.form$.value.$attrs.personFieldBeforeRepeater) {
                                for (let idx in $el.$parent.$parent.children$Array) {
                                    let fieldName = $el.$parent.$parent.children$Array[idx].name
                                    if (typeof component.form$.value.elements$.owner_person.value[fieldName] != 'undefined') {
                                        component.isUpdatingRepeaterFields = true
                                        component.form$.value.elements$.owner_person.value[fieldName] = newVal ? $el.$parent.$parent.children$Array[idx].value : null
                                        for (let i in component.form$.value.elements$.owner_person.children$Array) {
                                            if (component.form$.value.elements$.owner_person.children$Array[i].name == fieldName) {
                                                component.form$.value.elements$.owner_person.children$Array[i]._.props.disabled = newVal
                                            }
                                        }
                                    }
                                }
                            } else if (hasContactForm) {
                                for (let idx in $el.$parent.$parent.children$Array) {
                                    let fieldName = $el.$parent.$parent.children$Array[idx].name
                                    if (typeof component.form$.value.elements$.owner_person.value[fieldName] != 'undefined') {
                                        $el.$parent.$parent.children$Array[idx].value = newVal ? component.form$.value.elements$.owner_person.value[fieldName] : null
                                    }
                                }
                            }
                            window.setTimeout(function() {
                                component.isUpdatingRepeaterFields = false
                            })
                        };
                    }

                    Object.keys(schema).forEach(key => {
                        const field = schema[key];
                        field.floating = field.label;
                        delete field.label;
                        schema[key] = field;
                    })

                    return Object.assign({}, {schema}, {type: 'object', size: 'sm', initial: 1, min: 1})
                })
            }

            component.getProtoType = (prototype, i) => {
                prototype.schema.index = {
                    type: 'hidden',
                    meta: true,
                    default: i
                }
                return prototype;
            }
            // cleanup submit data
            component.requestData = computed(() => {
                // Reduce file/image values to their tmp UUID and deep-clone so the
                // live value model is never mutated. The stock Vueform list.requestData
                // descends into each child's requestData (which the top-level filesPlugin
                // reduces to the UUID string); this custom override reads value.value raw,
                // so without this reduction repeater image fields submit the raw
                // {tmp, originalName, __file__} object and break the server (FWT: repeater
                // image upload -> File::find(array) -> Collection -> "Property [path]...").
                const reduceFiles = (val) => {
                    if (Array.isArray(val)) return val.map(reduceFiles)
                    if (val && typeof val === 'object') {
                        if ('tmp' in val) return val.tmp
                        const out = {}
                        Object.keys(val).forEach(k => { out[k] = reduceFiles(val[k]) })
                        return out
                    }
                    return val
                }
                const entries = component.value.value.map(entry => {
                    const clean = reduceFiles(entry)
                    if (!clean.id) delete clean.id
                    return clean
                })
                return { [component.dataPath.value]: entries }
            })
            component.on('mounted',(el$)=> {
                setTimeout(() => {
                    const listValues = component.value.value;
                    listValues.forEach((entry, index) => {
                        // handle fields that are not changeable
                        el$.children$Array[index].children$Array.forEach(child => {
                            const element = el$.children$Array[index].schema[child.name];
                            const value = component.value.value[index][child.name];
                            // if (element.rules && element.rules.includes('required') && value) {
                            // why making required fields readonly?
                            if (component.value.value[index].has_redeemed_tickets) {
                                const input = child.$.refs.input;
                                if (input && input.setAttribute) {
                                    // todo: readonly will not work for non-text-fields
                                    // todo: potential clash with automatic setting of disabled in CASE ONE
                                    input.setAttribute('readonly',true);
                                }
                            }
                        })
                    })
                });
            })

            // --- Bulk member upload (CSV / Excel) -----------------------------
            // Lets a contact person import group members from a file instead of
            // typing each row by hand. Parsed rows are appended as ordinary
            // repeater entries, so the existing submit path (php-core
            // PersonService) runs workflow init, calculation fields and triggers
            // exactly like manual entry — no separate import endpoint needed.
            const CORE_FIELD_SYNONYMS = {
                firstname: ['firstname', 'vorname', 'givenname', 'prename', 'forename'],
                name: ['name', 'nachname', 'lastname', 'surname', 'familyname', 'familienname'],
                email: ['email', 'emailaddress', 'mail', 'emailadresse', 'mailadresse'],
                phone: ['phone', 'mobile', 'mobil', 'telefon', 'telephone', 'handy', 'tel', 'mobilnummer', 'telefonnummer', 'phonenumber'],
            };
            const SKIP_FIELD_TYPES = ['static', 'html', 'hidden', 'button', 'object', 'list', 'signature'];
            const SKIP_FIELD_NAMES = ['is_owner_person', 'index'];

            // `*` and `:` are stripped as well: Vueform renders a required marker next
            // to the label (`showRequired`), and users who copy the on-screen column
            // names into their spreadsheet bring it along ("Handy *" / "Handy:").
            const normalizeHeader = (s) => String(s ?? '').toLowerCase().replace(/[\s._\-()*:]/g, '').trim();

            const importSchema = () => {
                const proto = component.prototype && component.prototype.value;
                if (proto && proto.schema) {
                    return proto.schema;
                }
                return (props.object && props.object.schema) ? props.object.schema : {};
            };
            // php-core emits labels as a multilingual {de,en,…} map (Vueform localizes
            // at render time), so a plain-string check returns nothing for virtually
            // every real form — header matching then fell back to the technical field
            // name and the template download shipped `phone_mobile` instead of "Handy".
            // Same handling as optionFieldMap() already does for option labels.
            const localizeLabel = (lbl) => {
                if (typeof lbl === 'string') return lbl;
                if (!lbl || typeof lbl !== 'object') return '';
                const lang = component.form$.value.locale$ || 'de';
                const val = lbl[lang] || lbl.de || lbl.en || '';
                return typeof val === 'string' ? val : '';
            };
            // Four sources, because a repeater child rarely has the obvious one.
            // Verified live against a real portal form (evolve2026 Artists), not read
            // off the JSON — getRepeatableFields() is the only honest source here:
            //   - `label` is unset for every repeater child (the child mapper moves it
            //     to `floating`, and to `before` first for a `boolean`, so `floating`
            //     ends up as the empty string and drops out of the payload).
            //   - `before` carries the caption of a yes/no field (`case 'boolean'`).
            //   - `placeholder` carries it for everything else — setPublicTranslationArray
            //     fills it from the field's label.
            // Without `placeholder` the download template handed contributors
            // `firstname;name;email;kennzeichen` — technical names — and a file written
            // with the captions shown in the form only matched the core columns, and
            // then only via CORE_FIELD_SYNONYMS.
            const labelSource = (field) => field
                && (field.floating || field.label || field.before || field.placeholder);
            const fieldLabel = (field) => localizeLabel(labelSource(field));
            // Every locale's label, so a file built from the English form still imports
            // into a German session (and vice versa).
            const labelAliases = (field) => {
                const lbl = labelSource(field);
                if (typeof lbl === 'string') return [lbl];
                if (!lbl || typeof lbl !== 'object') return [];
                return Object.values(lbl).filter((s) => typeof s === 'string' && s !== '');
            };
            const isDataField = (name, field) => {
                if (!field || SKIP_FIELD_NAMES.includes(name)) return false;
                if (field.meta) return false;
                if (field.type && SKIP_FIELD_TYPES.includes(field.type)) return false;
                if (field.schema || field.object) return false;
                return true;
            };
            const importableFields = () => {
                const schema = importSchema();
                return Object.keys(schema)
                    .filter((name) => isDataField(name, schema[name]))
                    .map((name) => ({name, label: fieldLabel(schema[name]) || name}));
            };
            // Phone fields render via the intl-tel-input element and only ingest a
            // value the widget can parse (effectively E.164). Raw imported strings
            // (00-prefix, bare national, too short) get cleared, so we normalize them.
            const phoneFieldNames = () => {
                const schema = importSchema();
                // Backend emits phone fields as type 'newPhone' (VueFormController);
                // keep 'phone' as a fallback for any built-in phone elements.
                return new Set(Object.keys(schema).filter((name) => {
                    const t = schema[name] && schema[name].type;
                    return t === 'newPhone' || t === 'phone';
                }));
            };
            // Default region DE only — international handling is a follow-up ticket.
            const normalizePhone = (raw, parse) => {
                let s = String(raw == null ? '' : raw).trim();
                if (!s || !parse) return s;
                if (s.startsWith('00')) s = '+' + s.slice(2);
                const tryParse = (val) => {
                    try {
                        const p = parse(val, 'DE');
                        return (p && p.isValid()) ? p.number : null; // E.164, e.g. +49151…
                    } catch (e) { return null; }
                };
                const direct = tryParse(s);
                if (direct) return direct;
                // Excel stores phone numbers typed as plain digits as numbers and
                // drops the leading 0 (0151… -> 151…). For a bare national number,
                // restore the German trunk prefix and retry so customers don't have
                // to format the column as text first.
                if (!s.startsWith('+') && !s.startsWith('0') && /^[0-9\s/()-]+$/.test(s)) {
                    const restored = tryParse('0' + s.replace(/[\s/()-]/g, ''));
                    if (restored) return restored;
                }
                return s; // leave raw so the user can correct it
            };

            // Select / multiselect fields (e.g. the role dropdown) expect an option
            // value (key), not the label. Map an imported cell to that key by a
            // case-insensitive match against the option labels (or the raw key).
            // One value per cell — multiple roles in one cell are not split.
            const normalizeOption = (s) => String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ' ').trim();
            // php-core renders a form-def `multiselect` as the Vueform `tags` element
            // (VueFormController), so a multi-value column arrives with type `tags` and
            // was skipped here entirely — the raw cell string went into the value and the
            // element dropped it. `multiselect` stays listed for schemas that use it.
            const MULTI_OPTION_TYPES = ['multiselect', 'tags'];
            const optionFieldMap = () => {
                const schema = importSchema();
                const lang = component.form$.value.locale$ || 'de';
                const out = {};
                Object.keys(schema).forEach((name) => {
                    const f = schema[name];
                    const t = f && f.type;
                    if (t !== 'select' && !MULTI_OPTION_TYPES.includes(t)) return;
                    const items = f.items || {};
                    const lookup = {};
                    const optionLabels = [];
                    const addAlias = (alias, key) => {
                        const n = normalizeOption(alias);
                        if (n) lookup[n] = key;
                    };
                    Object.keys(items).forEach((key) => {
                        const label = items[key];
                        // Accept the option key — with and without the `option_`
                        // prefix php-core prepends (shallOptionsBeConverted).
                        addAlias(key, key);
                        const bareKey = String(key).replace(/^option_/, '');
                        if (bareKey !== key) addAlias(bareKey, key);
                        // Labels arrive either as a plain string (e.g. member_roles)
                        // or a multilingual {de,en,…} object — Vueform localizes at
                        // render time, so the schema keeps the object. Index every
                        // locale string so the visible label matches in any language;
                        // resolve one for display in the warning.
                        let display = '';
                        if (typeof label === 'string') {
                            addAlias(label, key);
                            display = label;
                        } else if (label && typeof label === 'object') {
                            Object.values(label).forEach((s) => {
                                if (typeof s === 'string') addAlias(s, key);
                            });
                            display = label[lang] || label.de || label.en || '';
                        }
                        optionLabels.push(display || bareKey);
                    });
                    out[name] = {multiple: MULTI_OPTION_TYPES.includes(t), lookup, label: fieldLabel(f) || name, optionLabels};
                });
                return out;
            };

            // Yes/no fields arrive as Vueform `checkbox` (php-core maps form-def
            // `boolean` onto it). A checkbox only ingests its own trueValue/falseValue
            // — usually the booleans true/false, but php-core also emits '1'/'0' string
            // pairs — so an imported cell like "Ja" or "x" has to be mapped onto
            // whichever pair the field declares; the raw string was silently useless.
            const BOOLEAN_FIELD_TYPES = ['checkbox'];
            // Deliberately locale-independent: a file exported from a German session
            // must still import in an English one and vice versa, and spreadsheets
            // produce all of these ("x" from a tick column, TRUE/FALSE from Excel's
            // own boolean, 1/0 from a numeric column).
            const BOOLEAN_TRUE = ['ja', 'j', 'yes', 'y', 'true', 'wahr', 'x', '1'];
            const BOOLEAN_FALSE = ['nein', 'n', 'no', 'false', 'falsch', '0', '-'];
            const booleanFieldMap = () => {
                const schema = importSchema();
                const out = {};
                Object.keys(schema).forEach((name) => {
                    const f = schema[name];
                    if (!f || !BOOLEAN_FIELD_TYPES.includes(f.type)) return;
                    out[name] = {
                        label: fieldLabel(f) || name,
                        trueValue: f.trueValue === undefined ? true : f.trueValue,
                        falseValue: f.falseValue === undefined ? false : f.falseValue,
                    };
                });
                return out;
            };
            // undefined (not false) for an unrecognized cell, so the caller can tell
            // "no" apart from "could not read this".
            const parseBoolean = (raw, spec) => {
                const n = normalizeOption(raw);
                if (BOOLEAN_TRUE.includes(n)) return spec.trueValue;
                if (BOOLEAN_FALSE.includes(n)) return spec.falseValue;
                return undefined;
            };
            // Shown as the allowed values in the warning and as the sample cell in the
            // template — reuses the form's existing yes/no strings, so no new keys.
            const booleanLabels = () => [
                (translations.festiware && translations.festiware.yes) || 'Ja',
                (translations.festiware && translations.festiware.no) || 'Nein',
            ];

            // Only person-list repeaters get the upload (otherwise it makes no sense).
            const baseSchema = (props.object && props.object.schema) ? props.object.schema : {};
            component.bulkUploadEnabled = ['firstname', 'name', 'email'].some((k) => !!baseSchema[k]);
            // Only surface the phone-format hint when the repeater actually has a
            // phone column — otherwise the note is just noise.
            component.bulkHasPhoneField = phoneFieldNames().size > 0;
            component.bulkUpload = (translations.festiware && translations.festiware.repeater && translations.festiware.repeater.bulk_upload) || {};
            // Collapsed by default so the import area doesn't clutter the repeater;
            // a toggle button reveals it. State lives on the element instance
            // because Vueform element templates don't merge SFC methods/data.
            component.bulkExpanded = ref(false);
            component.toggleBulkUpload = () => { component.bulkExpanded.value = !component.bulkExpanded.value; };
            // Each message is {level: 'success' | 'warning' | 'error', text}.
            // Rendered as one colored callout per line in RepeaterElement.
            component.bulkImportMessages = ref([]);
            component.bulkMessageClass = (level) => ({
                success: 'uk-alert-success',
                warning: 'uk-alert-warning',
                error: 'uk-alert-danger',
            }[level] || 'uk-alert-primary');

            // Which field do the DE/EN synonyms of each core kind belong to? Person
            // forms rarely use the bare core name — the standard person field is
            // `phone_mobile`, so keying the synonyms off the literal name `phone` meant
            // "Handy"/"Telefon"/"Mobilnummer" never matched anything. Fall back to a
            // type/name match, but only when it is UNAMBIGUOUS: a repeater with two
            // phone columns must not have one of them silently guessed.
            const coreTargets = (fields) => {
                const schema = importSchema();
                const exact = (core) => (fields.some((f) => f.name === core) ? core : null);
                const unique = (pred) => {
                    const hits = fields.filter(({name}) => pred(name, schema[name] || {}));
                    return hits.length === 1 ? hits[0].name : null;
                };
                return {
                    firstname: exact('firstname') || unique((n) => /^(first_?name|vorname)$/.test(n)),
                    name: exact('name') || unique((n) => /^(last_?name|nachname|surname|family_?name)$/.test(n)),
                    email: exact('email') || unique((n, f) => f.inputType === 'email' || /e?_?mail/.test(n)),
                    phone: exact('phone') || unique((n, f) => f.type === 'newPhone' || f.type === 'phone' || /(phone|mobil|telefon|handy)/.test(n)),
                };
            };

            const buildHeaderMap = () => {
                const fields = importableFields();
                const schema = importSchema();
                const map = {};
                fields.forEach(({name}) => {
                    map[normalizeHeader(name)] = name;
                    labelAliases(schema[name]).forEach((alias) => {
                        const key = normalizeHeader(alias);
                        if (key) map[key] = name;
                    });
                });
                const targets = coreTargets(fields);
                Object.keys(CORE_FIELD_SYNONYMS).forEach((core) => {
                    const target = targets[core];
                    if (!target) return;
                    CORE_FIELD_SYNONYMS[core].forEach((syn) => {
                        const key = normalizeHeader(syn);
                        if (!map[key]) map[key] = target;
                    });
                });
                return map;
            };

            const parseFile = async (file) => {
                const ext = (file.name.split('.').pop() || '').toLowerCase();
                if (ext === 'xlsx' || ext === 'xls') {
                    const XLSX = await import('xlsx');
                    const buf = await file.arrayBuffer();
                    const wb = XLSX.read(buf, {type: 'array'});
                    const sheet = wb.Sheets[wb.SheetNames[0]];
                    return sheet ? XLSX.utils.sheet_to_json(sheet, {defval: '', raw: false}) : [];
                }
                // papaparse is a CommonJS module: in the built bundle the dynamic
                // import resolves to the Papa object itself, which has no `.default`.
                // Reading `.default` yielded undefined and every CSV import threw
                // ("please use a CSV/Excel file") — accept both module shapes.
                const papaModule = await import('papaparse');
                const Papa = papaModule.default || papaModule;
                // Read the file to text ourselves rather than letting papaparse stream
                // the File. The synchronous string parser auto-detects the delimiter
                // (';' for German Excel exports, ',' otherwise) reliably, and this lets
                // us recover from non-UTF-8 encodings — German Excel writes CSV as
                // Windows-1252, so umlauts would otherwise arrive garbled.
                const buf = await file.arrayBuffer();
                let text;
                try {
                    text = new TextDecoder('utf-8', {fatal: true}).decode(buf);
                } catch (e) {
                    text = new TextDecoder('windows-1252').decode(buf);
                }
                const result = Papa.parse(text, {header: true, skipEmptyLines: 'greedy'});
                return result.data || [];
            };

            // A pre-existing row counts as empty when none of its importable data
            // fields hold a value. The contact-person row is never dropped.
            const isEmptyRow = (row) => {
                if (!row || typeof row !== 'object') return true;
                if (row.is_owner_person) return false;
                // An untouched checkbox holds its falseValue (`false`, or the string
                // '0' when php-core declares one), which String()s to a non-empty
                // "false"/"0" — so a form with any yes/no field never had its blank
                // default row recognised as empty, and the import appended below it.
                const booleans = booleanFieldMap();
                return importableFields().every(({name}) => {
                    const v = row[name];
                    if (Array.isArray(v)) return v.length === 0;
                    if (booleans[name]) return v === null || v === undefined || v === '' || v === booleans[name].falseValue;
                    return v === null || v === undefined || String(v).trim() === '';
                });
            };
            const removeEmptyRows = () => {
                const list = component.value.value || [];
                for (let i = list.length - 1; i >= 0; i--) {
                    if (isEmptyRow(list[i])) component.remove(i);
                }
            };

            component.handleBulkImport = async (event) => {
                const input = event.target;
                // The repeater's upload container — used to scroll the feedback
                // into view after the import so errors/warnings aren't missed.
                const bulkRoot = input.closest('.vf-repeater-bulk');
                // Publish the result messages and scroll them into view once the
                // DOM has rendered them, so the user immediately sees any problems.
                const showMessages = (msgs) => {
                    component.bulkImportMessages.value = msgs;
                    if (!bulkRoot) return;
                    nextTick(() => {
                        const box = bulkRoot.querySelector('.vf-repeater-bulk-messages') || bulkRoot;
                        if (box.scrollIntoView) box.scrollIntoView({behavior: 'smooth', block: 'center'});
                    });
                };
                const file = input.files && input.files[0];
                input.value = ''; // allow re-selecting the same file
                if (!file) return;
                component.bulkImportMessages.value = [];
                // Blocking progress modal from file-select to the final batch commit.
                // A real UIkit modal (not a Vue-rendered overlay nested inside the
                // repeater) — `dialog()` appends it straight to <body>, so it can't
                // inherit a `transform` from some ancestor (the sortable/list
                // container, an animation wrapper, …) and get dragged along with it.
                // That's exactly what happened with the first attempt: a `position:
                // fixed` div nested in the repeater's own DOM jumped whenever a new
                // row's transform-based mount/transition ran.
                // No close button, no bgClose/escClose — nothing else is reachable
                // while this is up. Always hidden via the try/finally below, on every
                // return path (including early-exit error branches).
                const progressModal = window.UIkit.modal.dialog(
                    '<div class="uk-modal-body uk-text-center">'
                    + '<p class="vf-bulk-progress-label uk-margin-remove-bottom"></p>'
                    + '<progress class="uk-progress uk-margin-small-top vf-bulk-progress-bar" value="0" max="1"></progress>'
                    + '</div>',
                    {bgClose: false, escClose: false}
                );
                const setProgress = (label, done, total) => {
                    const el = progressModal.$el;
                    const labelEl = el.querySelector('.vf-bulk-progress-label');
                    const barEl = el.querySelector('.vf-bulk-progress-bar');
                    if (labelEl) labelEl.textContent = label;
                    if (barEl) { barEl.value = done; barEl.max = total || 1; }
                };
                setProgress(component.bulkUpload.progress_reading || 'Reading file…', 0, 1);
                try {
                let rows;
                try {
                    rows = await parseFile(file);
                } catch (e) {
                    showMessages([{level: 'error', text: component.bulkUpload.error || 'Import failed.'}]);
                    return;
                }
                const map = buildHeaderMap();
                const phoneFields = phoneFieldNames();
                const optionFields = optionFieldMap();
                const booleanFields = booleanFieldMap();
                let parsePhone = null;
                if (phoneFields.size) {
                    // /max, not the plain package — shares one bundle with PhoneElement.vue's
                    // own dynamic import (which needs /max's fuller metadata for getType());
                    // two different specifiers for the same package produce two chunks Parcel
                    // can't both name "libphonenumber-js", and the build fails outright.
                    // Stay permissive on failure (normalization is skipped, raw values still
                    // import) — but report it, so a chunk 404 doesn't silently disable phone
                    // normalization for an entire import with no trace anywhere. console alone
                    // wouldn't leave the browser: this bundle's Sentry has no captureConsole
                    // integration (see sentry.js).
                    try {
                        parsePhone = (await import('libphonenumber-js/max')).parsePhoneNumberFromString;
                    } catch (e) {
                        console.error('[bulkImport] failed to load libphonenumber-js/max', e);
                        if (typeof window.reportFewException === 'function') {
                            window.reportFewException(e, {tags: {area: 'repeater-bulk-import', cause: 'chunk-load'}});
                        }
                    }
                }
                // Respect the repeater's max — never add more rows than allowed.
                const maxRows = (typeof props.max === 'number' && props.max >= 0) ? props.max : -1;
                const unmatched = new Set();
                // Unresolved select values, grouped per target field so the warning
                // can name the affected column and list its allowed options.
                const unresolvedByField = new Map();
                const addUnresolvedValue = (target, label, optionLabels, val) => {
                    let bucket = unresolvedByField.get(target);
                    if (!bucket) {
                        bucket = {label, optionLabels, values: new Set()};
                        unresolvedByField.set(target, bucket);
                    }
                    bucket.values.add(val);
                };
                // Build the importable rows first, then commit them — so empty
                // pre-existing rows can be dropped before counting against the max.
                const entries = [];
                (rows || []).forEach((raw) => {
                    const entry = {};
                    Object.keys(raw).forEach((header) => {
                        const target = map[normalizeHeader(header)];
                        if (!target) {
                            if (String(header).trim() !== '') unmatched.add(String(header).trim());
                            return;
                        }
                        let v = raw[header];
                        v = (v === null || v === undefined) ? '' : String(v).trim();
                        if (v === '') return;
                        const bool = booleanFields[target];
                        if (bool) {
                            const parsed = parseBoolean(v, bool);
                            if (parsed === undefined) {
                                addUnresolvedValue(target, bool.label, booleanLabels(), v);
                            } else {
                                entry[target] = parsed;
                            }
                            return;
                        }
                        if (phoneFields.has(target)) {
                            entry[target] = normalizePhone(v, parsePhone);
                            return;
                        }
                        const opt = optionFields[target];
                        if (opt) {
                            // map e.g. a role name to its option value; leave empty when
                            // unrecognized so the field's own validation flags it on submit
                            const addUnresolved = (val) => addUnresolvedValue(target, opt.label, opt.optionLabels, val);
                            if (opt.multiple) {
                                // A multiselect cell may list several values (comma /
                                // semicolon / newline separated — typically quoted in the
                                // CSV). Try the whole cell first so an option label that
                                // itself contains a separator still matches, then fall back
                                // to splitting and mapping each value into the array.
                                const whole = opt.lookup[normalizeOption(v)];
                                if (whole !== undefined) {
                                    entry[target] = [whole];
                                    return;
                                }
                                const keys = [];
                                v.split(/[;,\n]+/).map((p) => p.trim()).filter((p) => p !== '').forEach((part) => {
                                    const key = opt.lookup[normalizeOption(part)];
                                    if (key !== undefined) {
                                        if (!keys.includes(key)) keys.push(key);
                                    } else {
                                        addUnresolved(part);
                                    }
                                });
                                if (keys.length) entry[target] = keys;
                                return;
                            }
                            const key = opt.lookup[normalizeOption(v)];
                            if (key !== undefined) {
                                entry[target] = key;
                            } else {
                                addUnresolved(v);
                            }
                            return;
                        }
                        entry[target] = v;
                    });
                    if (Object.keys(entry).length) entries.push(entry);
                });
                if (!entries.length) {
                    showMessages([{level: 'error', text: component.bulkUpload.empty || 'No rows found.'}]);
                    return;
                }
                // Drop the default blank row (and any other empty ones) before adding.
                removeEmptyRows();
                // Cap at the repeater's max, then commit in fixed-size batches instead
                // of one call per row (the old O(n^2) crash — see below) OR one single
                // write for the whole list. Vueform's list watcher (useWatchValue)
                // deep-watches the list value and re-validates the WHOLE array on every
                // write, so cost is O(current length) per write regardless of how many
                // rows that write adds. Many small per-row writes (component.add() in a
                // tight loop, no yield) summed to O(n^2) and froze/crashed the tab on a
                // 203-row Secu-crew import (Horst, buchtdertraeumer, 2026-08-05) — fixed
                // by collapsing to ONE write. Batches reintroduce a bounded amount of
                // that same per-write cost (a handful of writes, not hundreds) in
                // exchange for a responsive tab and a real progress readout between
                // batches — `await nextTick()` lets Vue actually flush/render each
                // batch before the next one starts.
                const currentLength = (component.value.value || []).length;
                const capacity = maxRows === -1 ? entries.length : Math.max(0, maxRows - currentLength);
                const toAdd = entries.slice(0, capacity).map((entry) => ({...entry, is_owner_person: 0}));
                const skippedLimit = entries.length - toAdd.length;
                const BATCH_SIZE = 25;
                // `await nextTick()` alone only waits for Vue to PATCH the DOM — that's
                // a microtask, and awaiting a microtask never hands control back to the
                // browser's task queue, so no actual paint happens between batches (the
                // progress bar sat at 0% the whole time, then jumped to done — Chrome's
                // own "page unresponsive" nag fired because the whole chain of batches
                // ran as one uninterrupted stretch from the browser's point of view).
                // A real yield needs a macrotask/animation-frame boundary. Double rAF is
                // the standard way to wait until AFTER a frame has actually painted: the
                // first rAF fires before that paint, its callback schedules the second
                // one, which only runs once the browser has rendered the frame.
                const paint = () => new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
                if (toAdd.length) {
                    const labelTemplate = component.bulkUpload.progress_importing || 'Importing … (:done/:total)';
                    const progressLabel = (done) => labelTemplate.replace(':done', done).replace(':total', toAdd.length);
                    setProgress(progressLabel(0), 0, toAdd.length);
                    await nextTick();
                    await paint();
                    for (let offset = 0; offset < toAdd.length; offset += BATCH_SIZE) {
                        const batch = toAdd.slice(offset, offset + BATCH_SIZE);
                        const merged = (component.value.value || []).concat(batch);
                        component.value.value = typeof component.refreshOrderStore === 'function'
                            ? component.refreshOrderStore(merged)
                            : merged;
                        const done = Math.min(offset + BATCH_SIZE, toAdd.length);
                        setProgress(progressLabel(done), done, toAdd.length);
                        // Let Vue patch the DOM for this batch, THEN wait for an actual
                        // painted frame, before the next (possibly slow) batch blocks
                        // the main thread again.
                        await nextTick();
                        await paint();
                    }
                }
                const added = toAdd.length;
                if (!added) {
                    // entries existed but none fit — the max is already filled.
                    const text = (component.bulkUpload.limit_full || 'Maximum reached.').replace(':max', maxRows);
                    showMessages([{level: 'error', text}]);
                    return;
                }
                // One message per line: success first, then warnings.
                const messages = [{level: 'success', text: (component.bulkUpload.imported || ':count').replace(':count', added)}];
                if (skippedLimit) {
                    messages.push({level: 'warning', text: (component.bulkUpload.limit || ':skipped/:max').replace(':skipped', skippedLimit).replace(':max', maxRows)});
                }
                if (unmatched.size) {
                    messages.push({level: 'warning', text: (component.bulkUpload.unmatched || ':columns').replace(':columns', Array.from(unmatched).join(', '))});
                }
                if (unresolvedByField.size) {
                    // One warning per affected select column: name it, list the
                    // unrecognized values and the options that would have matched.
                    unresolvedByField.forEach((bucket) => {
                        const text = (component.bulkUpload.unmatched_values || ':field: :values (:options)')
                            .replace(':field', bucket.label)
                            .replace(':values', Array.from(bucket.values).join(', '))
                            .replace(':options', bucket.optionLabels.join(', '));
                        messages.push({level: 'warning', text});
                    });
                }
                showMessages(messages);
                } finally {
                    progressModal.hide();
                }
            };

            const csvCell = (s) => {
                s = String(s == null ? '' : s);
                return /[";\n\r]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
            };
            // Classify a field into one of the core kinds so the template can fill
            // plausible example data. Uses the same resolution as the header map, so a
            // column named `email_private` / `phone_mobile` gets sample data too.
            const coreKind = (name) => {
                const targets = coreTargets(importableFields());
                return Object.keys(targets).find((core) => targets[core] === name) || null;
            };
            component.handleTemplateDownload = () => {
                const fields = importableFields();
                const schema = importSchema();
                const cols = fields.map((f) => f.label);
                const phoneFields = phoneFieldNames();
                const optionFields = optionFieldMap();
                const booleanFields = booleanFieldMap();
                // Emit one example row per available option of the first option field
                // (e.g. the role dropdown) so users see valid, ready-to-edit values.
                const primaryOption = Object.keys(optionFields)[0] || null;
                // Read the labels optionFieldMap() already localized — the raw `items`
                // values are multilingual maps for admin-authored options, which would
                // filter down to an empty list and cost the per-option example rows.
                const optionLabels = primaryOption
                    ? (optionFields[primaryOption].optionLabels || []).filter((l) => typeof l === 'string' && l !== '')
                    : [];
                const SAMPLE_FIRST = ['Alex', 'Sam', 'Kim', 'Toni', 'Robin', 'Luca', 'Charlie', 'Noa'];
                const SAMPLE_LAST = ['Beispiel', 'Muster', 'Probe', 'Vorlage', 'Test', 'Demo', 'Platzhalter', 'Person'];
                const SAMPLE_PHONE = '0151 23456789';
                const exampleRow = (idx, roleLabel) => {
                    const first = SAMPLE_FIRST[idx % SAMPLE_FIRST.length];
                    const last = SAMPLE_LAST[idx % SAMPLE_LAST.length];
                    return fields.map(({name}) => {
                        const of = optionFields[name];
                        if (of) {
                            if (name === primaryOption) return roleLabel;
                            // Show a valid multi-value example (two labels, comma-joined)
                            // for multiselect columns so the format is self-explanatory;
                            // single-select columns stay blank as before.
                            const labels = of.optionLabels || [];
                            return of.multiple ? labels.slice(0, 2).join(', ') : '';
                        }
                        if (booleanFields[name]) return booleanLabels()[0];
                        if (phoneFields.has(name)) return SAMPLE_PHONE;
                        const ftype = schema[name] && schema[name].type;
                        const kind = coreKind(name);
                        if (kind === 'firstname') return first;
                        if (kind === 'name') return last;
                        if (kind === 'email' || ftype === 'email') return (first + '.' + last + '@example.org').toLowerCase();
                        return '';
                    });
                };
                const dataRows = optionLabels.length
                    ? optionLabels.map((label, i) => exampleRow(i, label))
                    : [exampleRow(0, '')];
                const lines = [cols.map(csvCell).join(';')]
                    .concat(dataRows.map((row) => row.map(csvCell).join(';')));
                const csv = '\uFEFF' + lines.join('\r\n') + '\r\n';
                const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = (component.bulkUpload.template_filename || 'import-template') + '.csv';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            };
            // ------------------------------------------------------------------
        }
        return component;
    }
}

const staticSelectsPlugin = {
    apply: 'SelectElement',
    props: {staticType: {required: false, type: String}},
    setup(props, context, component) {
        if (props.staticType === 'country') {
            let result = [];
            let hasAutoFill = false;
            component.resolvedOptions = async () => {
                let locale = inject('form$').value.locale$ || inject('config$').value.i18n.locale
                result = (await axios.get('/getcountries/'+locale)).data
                return result;
            }

            // Very dirty hack to handle autofill
            component.on('search-change', async (search, el$) => {
                setTimeout(() => {
                    if (hasAutoFill) {
                        const searchResult = result.find(country => country.label.toLowerCase() === search.toLowerCase());
                        if (searchResult) {
                            el$.update(searchResult.value);
                        }
                        el$.$refs.input.deactivate();
                    }
                },20)
            });
            document.addEventListener('animationstart', function(e) {
                if (e.animationName === 'autofill-detect') {
                    hasAutoFill = true;
                }
            });
        }
        return component;
    }
}

const signaturePlugin = {
    apply: 'SignatureElement',
    setup(props, context, component) {
        // FWT-1616: the submitted signature must not be read from the LIVE pad at submit
        // time. Vueform's resizePad() -> clearDrawnSignature() wipes the pad canvas on any
        // input width change (mobile orientation / virtual keyboard / step-navigation
        // re-layout) but leaves `value` a Blob. Reading pad.toDataURL() at submit then
        // yields a BLANK image while `required` still passes -> empty signatures that later
        // block saving in the MWP.
        //
        // Fix: snapshot the drawing to a data URL the moment the value becomes a Blob (the
        // pad still holds the drawing then), via Vueform's EXISTING 'change' event. A later
        // pad clear can no longer blank the submitted signature.
        //
        // NB: do NOT use a reactive `watch` on the value here — that added an extra reactive
        // dependency that re-rendered the element and cleared the pad before capture, breaking
        // signature drawing entirely (v1.12.13, reverted in v1.12.15). Subscribing to the
        // change event is not a reactive effect and is safe.
        //
        // FWT-1817: the change-event snapshot alone still submitted a PARTIAL signature.
        // Vueform commits the drawing incrementally — every stroke-end pause > 500ms writes
        // the pad's current state to `value` (a fragment, e.g. just the first dot). When a
        // resize then wipes the pad before the final commit, drawingToImage finds an empty
        // canvas and silently keeps the old fragment value, so the fragment is what got
        // submitted. Two additions fix this:
        // 1. Also snapshot on the pad's own 'endStroke' event (a plain SignaturePad
        //    EventTarget listener, not a reactive effect): at stroke end the pad is
        //    guaranteed to hold the complete drawing so far — before the 500ms debounce and
        //    before any resize wipe can race it. Attached lazily on the first Blob commit,
        //    when `el.pad` is guaranteed to exist; strokes before that first commit need no
        //    snapshot because without a Blob value nothing is submitted anyway.
        // 2. The cache must be a ref: requestData is a computed, and with a plain closure
        //    variable it froze on its first evaluation and never saw later snapshots.
        //    Writing the ref from event callbacks is not a reactive effect on the element
        //    (unlike the v1.12.13 watch) — it only marks requestData dirty.
        const cachedDataUrl = ref('');
        let endStrokeAttached = false;
        const snapshotPad = (pad) => {
            // Never overwrite a good snapshot with a wiped canvas (a resize can clear the
            // pad between the value commit and this handler running). isEmpty() is
            // stroke-data-based, so a wiped pad reports empty even before a repaint.
            if (pad && !pad.isEmpty()) {
                cachedDataUrl.value = pad.toDataURL();
            }
        };
        component.on('change', () => {
            const el = component.el$.value;
            const val = el && el.value;
            if (val instanceof Blob && el.pad) {
                snapshotPad(el.pad);
                if (!endStrokeAttached) {
                    endStrokeAttached = true;
                    el.pad.addEventListener('endStroke', () => {
                        const el$ = component.el$.value;
                        snapshotPad(el$ && el$.pad);
                    });
                }
            } else if (!val) {
                cachedDataUrl.value = '';
            }
        });
        component.requestData = computed( () => {
            const el = component.el$.value;
            if (el.value instanceof Blob) {
                // Prefer the snapshot taken while the pad still held the drawing; fall back to
                // the live pad only if no snapshot was captured yet, so we never submit ''.
                const value = cachedDataUrl.value || (el.pad ? el.pad.toDataURL() : '');
                return { [component.dataPath.value]: value }
            } else if (!el.value) {
                return {[component.dataPath.value]: ''};
            } else {
                return false;
            }
        });

        // FWT-1817 (bug 2): a pad whose element is hidden when the pad is created gets
        // canvas width 0 and stays undrawable forever. Vueform's initPad() early-returns
        // once the pad instance exists, and only a WINDOW resize with a width change ever
        // calls resizePad() — which never happens on mobile. Concrete case: a signature
        // field behind a condition (e.g. "Befreiung von der Rentenversicherungspflicht"
        // = Ja) whose condition is already true from stored data while the field's tab is
        // not the active one — the pad initialises inside the display:none tab at width 0,
        // and selecting the tab later resizes nothing. A DOM ResizeObserver on the
        // element's input container (NOT a reactive Vueform watch — see the v1.12.13
        // lesson above) re-runs Vueform's own resizePad() whenever the rendered width
        // actually changes, e.g. 0 -> real width on reveal. Width-change guard included,
        // so this adds no new pad-wipe cases beyond what the window-resize handler
        // already does (and the submitted value survives wipes via the snapshot above).
        component.on('mounted', () => {
            if (typeof ResizeObserver === 'undefined') return;
            const el = component.el$.value;
            const target = el && (el.input || el.$el);
            if (!target || !target.getBoundingClientRect) return;
            let lastWidth = target.getBoundingClientRect().width;
            const observer = new ResizeObserver(() => {
                const el$ = component.el$.value;
                if (!el$ || !el$.pad) return;
                const width = target.getBoundingClientRect().width;
                if (!width || width === lastWidth) return;
                lastWidth = width;
                if (typeof el$.setLastWidth === 'function') el$.setLastWidth();
                if (typeof el$.resizePad === 'function') el$.resizePad();
            });
            observer.observe(target);
            component.on('beforeUnmount', () => observer.disconnect());
        });
        return component;
    }
}

const datesPlugin = {
    apply: 'DateElement',
    props: {
        extendOptions: {
            required: false,
            type: [Object],
            default: () => ({
                disableMobile: true,
                // Vueform forces flatpickr `static: true`, so the calendar lives in-flow
                // inside the form wrapper and flatpickr's own auto-flip (positionCalendar
                // bails out early for static calendars) never runs — by default the
                // static calendar always sits *below* the input. We replicate flatpickr's
                // native `showOnTop` decision here: only open the calendar above the input
                // when there isn't enough room below AND it fully fits above. Otherwise it
                // would be clipped off the top of the viewport — the bug reported for the
                // "Teammembers" / "Food Vendors" arrival-date fields (Helpscout #3351548641).
                onOpen: function() {
                    setTimeout(() => {
                        const calendar = this.calendarContainer;
                        if (!calendar) {
                            return;
                        }
                        const input = this._positionElement || this.input;
                        const inputRect = input.getBoundingClientRect();
                        const calendarHeight = calendar.offsetHeight;
                        const spaceBelow = window.innerHeight - inputRect.bottom;
                        const spaceAbove = inputRect.top;
                        const showOnTop = spaceBelow < calendarHeight && spaceAbove > calendarHeight;
                        if (showOnTop) {
                            calendar.style.top = 'auto';
                            calendar.style.bottom = 'calc(100% + 2px)';
                        } else {
                            // restore flatpickr's default static position (below the input)
                            calendar.style.top = '';
                            calendar.style.bottom = '';
                        }
                    }, 0);
                },
            }),
        },
    },
}

// ---------------------------------------------------------------------------
// Date fields rendered as a masked text input ("Als Texteingabe im Frontend")
// ---------------------------------------------------------------------------
// php-core emits `dateText: true` + an IMask config (`00.00.0000`) instead of
// `type: 'date'` when an admin ticks that option on a date field.
//
// Why the variant exists: for dates the user knows by heart — birthdates above all —
// a calendar picker is the wrong pattern, and on mobile it is actively painful.
// Vueform hardcodes `disableMobile: true` inside its DatepickerWrapper *after* merging
// our `extendOptions` (see datesPlugin above), so the native mobile picker cannot be
// reached from here at all; users are stuck with flatpickr's own widget, whose year
// selector is a stepper — dozens of taps to reach a birth year.
//
// Value contract: the mask keeps the model in DD.MM.YYYY and only yields a value once
// all eight digits are typed. The submit payload is converted to the very same
// YYYY-MM-DD the picker variant sends (see normalizeDateTextValues in FormApp.vue), so
// no php-core consumer needs to know which variant rendered the field.
const DATE_TEXT_PATTERN = /^(\d{2})\.(\d{2})\.(\d{4})$/;

// Strict DD.MM.YYYY parse. The mask only enforces digit positions, so non-existent
// calendar dates (31.02.1990, 00.00.0000) still reach us and must be rejected here.
const parseDateText = (input) => {
    const match = DATE_TEXT_PATTERN.exec(String(input ?? '').trim());
    if (!match) {
        return null;
    }
    const day = Number(match[1]);
    const month = Number(match[2]);
    const year = Number(match[3]);
    const date = new Date(Date.UTC(year, month - 1, day));
    // Date.UTC rolls overflow over (Feb 31 -> Mar 3), so compare the parts back.
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) {
        return null;
    }
    return {day, month, year};
}

const dateTextToIso = (input) => {
    const parsed = parseDateText(input);
    if (!parsed) {
        return null;
    }
    return [
        String(parsed.year).padStart(4, '0'),
        String(parsed.month).padStart(2, '0'),
        String(parsed.day).padStart(2, '0'),
    ].join('-');
}

// Declaring the prop is what makes the schema key reach the element and keeps
// `el$.dateText` readable for the submit-time normalization walker.
//
// MUST stay after MaskPlugin in vueform.config.js `plugins`: the installer chains
// `setup = plugin.setup(props, context, setup)` in array order, so `component.Mask` /
// `component.syncMask` only exist here if the mask plugin ran first.
const dateTextPlugin = {
    apply: 'TextElement',
    props: {
        dateText: {
            required: false,
            type: [Boolean],
            default: false,
        },
    },
    setup(props, context, component) {
        if (!props.dateText) {
            return component;
        }

        // Mask visibility follows focus. At rest the field keeps IMask's `lazy: true`
        // so an empty field shows the TT.MM.JJJJ placeholder instead of "__.__.____"
        // (several optional date fields would otherwise all look pre-filled). From the
        // first focus the full template stays on screen — "15.03.____" tells the user
        // how many digits are still missing, which is the whole reason for the variant.
        //
        // Safe against the dirty flag: toggling `lazy` changes only the *display*.
        // IMask reports `isComplete === false` for an empty or partial field, so the
        // mask plugin's syncMask() writes `nullValue` to the element value — unchanged
        // from before, so useWatchValue's `dataEquals` check bails out and dirt() never
        // runs. A field that is merely focused and left therefore stays clean and is not
        // submitted, which would otherwise null out a stored date in update forms.
        const applyLazy = (lazy) => {
            const mask = component.Mask?.value;
            if (!mask) {
                return;
            }
            mask.updateOptions({lazy});
            // Keeps `model` in step with what IMask just rendered into the DOM, so a
            // later re-render cannot clobber the input with a stale display value.
            component.syncMask();
        }

        component.on('focus', () => applyLazy(false));
        component.on('blur', () => applyLazy(true));

        return component;
    }
}

const filesPlugin = {
    apply: 'FileElement',
    props: {staticType: {required: false, type: String}},
    setup(props, context, component) {
        component.dirty = computed(() => {
            const value = component.value.value;
            return !(!value || (typeof value === 'string' && value.startsWith('http')))
        });
        component.requestData = computed(() => {
            let value = component.value.value;
            value = (value && typeof value === 'object' && value.tmp) ? value.tmp : value;
            return { [component.dataPath.value]: value }
        });
        // Reset file field after upload error so user can retry
        component.on('error', () => {
            setTimeout(() => {
                component.hasUploadError.value = false;
                component.update(null);
            });
        });
        return component;
    }
}

/**
 * `selfie` fields stay FileElements — php-core sends them as `type: 'file'` with an
 * extra `selfie` prop (VueFormController::selfieOptions()) — so the temp upload,
 * soft remove and validation path is the one every other upload already uses. Only
 * the template is swapped: a crop stage locked to the project's pass photo ratio,
 * plus a camera capture path.
 *
 * The prop must be declared here; an undeclared attribute would land in `attrs`
 * instead of on the element, and the template could never read the ratio.
 *
 * @warn Everything the template binds to has to be put on `component` HERE. vueform
 *   renders the override's `<template>` only — `computed`/`methods` declared inside
 *   SelfieElement.vue are never called, which surfaces as "Cannot read properties of
 *   undefined" on the first binding that needs them. Same contract as RepeaterPlugin.
 */
const selfiePlugin = {
    apply: 'FileElement',
    props: {selfie: {required: false, type: [Object, Boolean]}},
    setup(props, context, component) {
        if (!props.selfie) {
            return component;
        }

        component.template = SelfieElement;

        const form$ = component.form$;

        component.selfieTranslations = computed(() => form$.value.translations?.festiware?.selfie || {});

        // The crop stage hands over a plain File — from here on it is an ordinary
        // upload, so mirror what handleChange() does for a picked file.
        component.handleSelfieCrop = async (file) => {
            component.update(file);

            // `auto` is a FileElement prop, not part of the composable's return.
            if (props.auto) {
                await component.uploadTemp();
            }

            if (form$.value.shouldValidateOnChange) {
                component.validate();
            }
        };

        component.handleSelfieNotice = (message) => {
            if (!message) return;

            if (window.UIkit && window.UIkit.notification) {
                window.UIkit.notification({message, status: 'warning', pos: 'top-center'});

                return;
            }

            window.alert(message);
        };

        return component;
    }
}

const localizedButtonsPlugin = {
    apply: 'ButtonElement',
    setup(props, context, component) {
        component.on('click', (el$, event) => {
            el$.form$.$nextTick(() => {
                if (el$.form$.tabs$ && el$.form$.tabs$.tabs$Array.filter(tab => tab.invalid).length > 0) {
                    document.querySelector('#new-form-app').scrollIntoView();
                }
            })
        });
        const config$ = inject('config$');
        const form$ = inject('form$');
        const defaultLabel = localize(props.buttonLabel, config$.value, form$.value);
        component.resolvedButtonLabel = computed(() => {
            if (form$.value.preparing) {
                const fileCount = Object.values(form$.value.elements$)
                    .filter(el => el.type === 'file' && el.stage === 1).length;
                if (fileCount > 0) {
                    const tpl = form$.value.translations.festiware?.uploading_files;
                    return tpl ? tpl.replace(':count', fileCount) : defaultLabel;
                }
            }
            return defaultLabel;
        });
        component.isButtonLabelComponent = false;
        return component;
    }
}

module.exports = {
    RepeaterPlugin,
    staticSelectsPlugin,
    localizedButtonsPlugin,
    filesPlugin,
    selfiePlugin,
    signaturePlugin,
    datesPlugin,
    dateTextPlugin,
    dateTextToIso,
    // Rejects anything the mask lets through that is not a real calendar date.
    // An empty value is left to the `required` rule; an incomplete one (fewer than
    // eight digits) fails the pattern and is reported here rather than being
    // silently dropped — the mask nulls the element value while the user still
    // sees their half-typed input.
    dateTextValidator: class extends Validator {check() {
        const model = this.element$.model;
        if (model === null || model === undefined || model === '') {
            return true;
        }
        return dateTextToIso(model) !== null;
    }},
    // Vueform's own `date` rule is `!!strtotime(value)`, and its strtotime port opens
    // with `while (str.length)` — so an empty date field (value `null`) does not fail
    // the rule, it throws. The rejection travels up through Validator.validate() →
    // element.validate() → FormStep.next()/submit, killing the click handler: the
    // visitor stays on the step with no error message and cannot get any further.
    // Only `nullable` in front of the rule would have skipped it, and that is up to
    // whoever typed the rule into the FormCreator. Empty stays the `required` rule's
    // business here, exactly as in dateTextValidator above.
    // Sentry FEW-FRONTEND-VUE-6Z — ~500 affected visitors on one registration form.
    dateValidator: class extends VueformDate {check(value) {
        if (value === null || value === undefined || value === '') {
            return true;
        }
        return super.check(value);
    }},
    phoneValidator: class extends Validator {check() {return this.element$.isValid()}},
    emailValidator: class extends Validator {check() {
        if (!this.element$.model && !this.element$.rules.includes('required')) {
            return true
        }
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(String(this.element$.model).toLowerCase());
    }}
}
